import {
    CREATE_MEMBERSHIP_SCHEDULE,
    CREATE_MEMBERSHIP_SCHEDULE_FAILURE,
    CREATE_MEMBERSHIP_SCHEDULE_SUCCESS,
} from 'store/actions/types';

export const createMembershipSchedule = (payload) => {
    return {
        type: CREATE_MEMBERSHIP_SCHEDULE,
        payload: payload,
    };
};

export const createMembershipScheduleFailure = (error) => {
    return {
        type: CREATE_MEMBERSHIP_SCHEDULE_FAILURE,
        error: error,
    };
};

export const createMembershipScheduleSuccess = (response) => {
    return {
        type: CREATE_MEMBERSHIP_SCHEDULE_SUCCESS,
        id: response.id,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/membership-schedules/createMembershipSchedules.js